import axios from 'axios';
import { API } from '../../config/site';

export const TOKEN_KEY = 'admin_token';

export const adminApi = () =>
  axios.create({ baseURL: API, headers: { Authorization: `Bearer ${sessionStorage.getItem(TOKEN_KEY)}` } });

export const errorText = (err, fallback = 'Etwas ist schiefgelaufen.') => {
  const d = err.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(' ');
  return fallback;
};

export const STATUSES = ['neu', 'kontaktiert', 'Call geführt', 'gewonnen', 'abgesagt'];
